import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.css']
})
export class TestingComponent implements OnInit {
  pdfSrc : any;
  viewDocuments: any = [];
  isDocumentLoading: boolean = false;
  uploadedDocs: any = [];
  appid: any = null;
  maxMB: any = "5MB";
  DocumentsToUpload: any = [];
  dtype: any = "PDF,JPG,PNG,JPEG";
  docTypeId: any;
  filebytes: string;
  isLoadingImg:boolean = false;
  filename: any;
  filetype: any;
  filedescription: string;
  filesize: any;
  img: any;
  user = { LastName: '' };
  selectItem: any;

  constructor(  private documenttypeSerivce: DocumenttypeService,private toastService:ToastNotificationService, private ref: ChangeDetectorRef, private toastr: ToastrService,private documentService: DocumentsServiceService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.documenttypeSerivce.getAll().subscribe((res:any) => {
      //console.log(res);
      this.uploadedDocs = [];
      if (res != null && res.length > 0) {
        this.uploadedDocs = res.filter((map) => { return map.is_for_vehicle == true });
        this.getUploadDocs();
      }
    });


  }
  getUploadDocs() {
    this.filename = "";
    if(this.selectItem!=undefined)
    {
    this.documentService.getVehicleEntryDocById(this.selectItem.VehicleEntry.id).subscribe((x:any) => {
      this.viewDocuments = [];
      if (x != null && x.length > 0) {
        for (let list of x) {
          let firstNum = list.document_link.indexOf('#')
          //console.log(list.document_link.substring(firstNum + 1))
          list.shareId = list.document_link.substring(firstNum + 1);
          let docs: any = this.uploadedDocs.filter((map) => { return map.id == list.document_type_id });
          if (docs != null && docs.length > 0) {
            docs[0].document_link = list.document_link;
          }

        }
        this.viewDocuments = x;
        
      }
      this.isDocumentLoading = false;
    }, error => {
      this.viewDocuments = [];
      this.filename = "";
      this.isDocumentLoading = false;

    });
  }
  }
  viewDoc(id, fileName) {
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes('.pdf')) {

      this.documentService.downloadpdf(id).subscribe(x => {
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;
        this.img = null;

        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoadingImg = false;
      })
      return
    }
    this.documentService.download(id).subscribe(x => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc = null
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      //console.log(this.img)
      this.isLoadingImg = false;
      // this.img = x;
    })

  }
  handleTempFileInput(event, id) {
    console.log(id);
    const reader = new FileReader();

    if (event.target.files && event.target.files.length > 0) {
      let file: any = null
      const count = event.target.files.length
      file = event.target.files[count - 1];
      let result = this.checkFileType(file.name);
      // item.document_type_id = this.docTypeData.id;
      // item.code = this.doctypesDesc.code
      // item.description=file.name;
      this.docTypeId = id;
      
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
        let file: any = null
        const count = event.target.files.length

        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);



        //if File type is in not found
        if (result != -1) {

          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

            reader.removeEventListener
            reader.readAsDataURL(file);
            reader.onload = () => {

              this.filebytes = reader.result.toString().split(',')[1]
              console.log(this.filebytes);
              this.filename = file.name,
              this.filetype = file.type
              this.filedescription = "upload"
              this.filesize = file.size
              //this.validateData(this.docTypeId);

              const formdata = new FormData()
              formdata.append('File', this.filebytes)
              formdata.append('file_name', this.filename)
              formdata.append('TypeOfFile', this.filetype)
              formdata.append('description', this.filedescription)
              formdata.append('FileSize', this.filesize)
              //formdata.append('vehicleEntryId', this.selectItem.VehicleEntry.id);
              formdata.append('VehicleName', 'VehicalName - ' + this.filename)
              formdata.append('UserLastName', this.user.LastName)
              formdata.append('documenttypeid', this.docTypeId)
              formdata.append('ApplicationId', this.appid)
              formdata.append('shareId', this.appid)

              this.DocumentsToUpload.push(formdata);

              let docs: any = this.uploadedDocs.filter((map) => { return map.id ==  this.docTypeId });
              //this.uploadedDocs = docs;
              if (docs != null && docs.length > 0) {
                docs[0].file_name = this.filename;
                docs[0].document_type_id = this.docTypeId;
                docs[0].document_link = this.filebytes;
                this.viewDocuments.push(docs[0]);
              }

             

            };
          }
          else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, 'File Upload Failed, Please try again.');


          }

        }
        else {
          let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
          this.toastService.error(`Only these file types are allowed: PDF`, 'File Upload Failed, Please try again.')
        }

      }

    }
  }
  onFileChange(pFileList: File[]){
    let file: any = null
    file = Object.keys(pFileList).map(key => pFileList[key]);
    this.toastService.error(`File uploaded successfully`, 'File Upload.');
  }
  
  logError(error) {
    console.error(error);
  }

  handleFileInput(event, id) {

    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file: any = null
      const count = event.target.files.length
      file = event.target.files[count - 1];
      let result = this.checkFileType(file.name);
      // item.document_type_id = this.docTypeData.id;
      // item.code = this.doctypesDesc.code
      // item.description=file.name;
      this.docTypeId = id;
      // this.uploadInfo.push(this.docTypeData);
      // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
        let file: any = null
        const count = event.target.files.length

        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);



        //if File type is in not found
        if (result != -1) {

          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

            reader.removeEventListener
            reader.readAsDataURL(file);
            reader.onload = () => {

              this.filebytes = reader.result.toString().split(',')[1]
              this.filename = file.name,
                this.filetype = file.type
              this.filedescription = "upload"
              this.filesize = file.size
              this.validateData(this.docTypeId);

            };
          }
          else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, 'File Upload Failed, Please try again.');


          }

        }
        else {
          let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
          this.toastService.error(`Only these file types are allowed: PDF`, 'File Upload Failed, Please try again.')
        }

      }

    }
  }
  checkFileType(fileName: string) {
    // from the file name derive the extension
    let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
    let fileTypesArray = allowedFileTypes.Value.toString().split(',');
    //check if file type is
    let ext = fileName.split('.')[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
    }
    return -1;
  }

  checkFileSize(fileSize: number) {
    // get the maximum file size
    let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
    let maxAllowedSize = allowedFileSize.Value; //it is in MB
    let document_sizeMB = (fileSize / 1000000);
    if (document_sizeMB <= maxAllowedSize)
      return 1;
    else return -1;
    //

  }
  validateData(documenttypeid: any) {
    this.postFile(documenttypeid);
  }
  postFile(documenttypeid: any) {
    throw new Error('Method not implemented.');
  }

  viewTempDoc(bytes, fileName) {
    console.log(bytes);
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes('.pdf')) {

      try{
        let response = this.base64ToArrayBuffer(bytes);
        let file = new Blob([response], { type: 'application/pdf' });            
        var fileURL = URL.createObjectURL(file);
        this.pdfSrc = fileURL;
        this.img =  null;

        this.isLoadingImg = false;
      }catch(e){
          console.error(e);
      }
      
      return
    }
  }

  base64ToArrayBuffer(base64:any):ArrayBuffer {
    var binary_string =  window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array( len );
    for (var i = 0; i < len; i++)        {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }


}
